export default __webpack_public_path__ + "static/media/CafeAvion-5.e91c3d9c.jpg";